import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';
import { AssistantChatWindowType } from '../chat/components/AssistantChatWindowType';

interface AssistantChatWindowProps {
    showMewsAssistant: boolean;
    assistantChatWindowType: AssistantChatWindowType;
}

const assistantChatWindowInitialState: AssistantChatWindowProps = {
    showMewsAssistant: false,
    assistantChatWindowType: AssistantChatWindowType.sideBar,
};

interface AssistantChatWindowStore extends AssistantChatWindowProps {
    setAssistantChatWindowState: (state: AssistantChatWindowProps) => void;
    setShowAssistantChatPanel: (show: boolean) => void;
    setAssistantChatWindowType: (type: AssistantChatWindowType) => void;
}

const assistantChatWindowStore = createStore<AssistantChatWindowStore>((set) => ({
    ...assistantChatWindowInitialState,
    setAssistantChatWindowState: (assistantChatWindowProps: AssistantChatWindowProps) =>
        set((state) => ({ ...state, ...assistantChatWindowProps })),
    setShowAssistantChatPanel: (showMewsAssistant: boolean) => set((state) => ({ ...state, showMewsAssistant })),
    setAssistantChatWindowType: (assistantChatWindowType: AssistantChatWindowType) =>
        set((state) => ({
            ...state,
            assistantChatWindowType,
        })),
}));

export const useAssistantChatWindowStore = () => useStore(assistantChatWindowStore);
